const appLogDebug = (...args) => {
    if (process.env.NODE_ENV !== 'development') {
        return;
    }

    console.debug(...args);
};

module.exports = {
    appLogDebug
};